// src/services/fair.service.ts
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

export interface Fair {
  id: string;
  name: string;
}

export async function fetchFairs(): Promise<Fair[]> {
  const q = query(collection(db, 'fairs'), orderBy('name'));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({
    id: d.id,
    name: d.data().name as string,
  }));
}
